import { fromCamelCase, displayAmount } from "../../PayslipHelper";
export const _getContributions = ({
  item,
  checkCase,
  styles,
  displayValues,
}) => {
  const deductions = [...(item?.contributions || [])];

  if (checkCase("isBasicBackpay")) {
    deductions.unshift(`BIR Withholding Tax: ${displayValues.tax}`);
  }

  return deductions.map((entry, index) => {
    const [key, value] = entry.split(":").map((s) => s.trim());

    const label = key === "BIR Withholding Tax" ? key : fromCamelCase(key);

    if (!key || !value || isNaN(value)) return null;

    return (
      <div style={styles.salaryRowSection} key={index}>
        <div style={styles.salaryRow}>
          <p style={styles.salaryRowLbl}>{label}</p>
          <p style={styles.amount}>{displayAmount(value)}</p>
        </div>
      </div>
    );
  });
};
